import { style, media } from 'typestyle'
import { important } from 'csx'
export const m0mdi = style(media({ maxWidth: 768 }, { margin: important('0px') }))
